import {
    STREAM_STATUS_STOPPED,
    STREAM_STATUS_STARTED,
    STREAM_STATUS_ERROR,

    STREAMING_STOPPED,
    STREAMING_STARTED,
    STREAMING_ERROR
} from '../constants/streaming';

// todo: maybe constraints in the state

const defaultStreamingState = {
    status: STREAMING_STOPPED,
    stream: null
};

export default function streamingStatus(state = defaultStreamingState, action) {
    switch(action.type) {
        case STREAM_STATUS_STOPPED: return {...state, status: STREAMING_STOPPED};
        case STREAM_STATUS_STARTED: return {status: STREAMING_STOPPED, stream: action.stream};
        case STREAM_STATUS_ERROR: return {...state, status: STREAMING_ERROR};
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/streamingStatus.js